import { Options } from 'vue-class-component';
import DeviceSettingsComponent from '../DeviceSettingsComponent';
import {
  RelayStatusAfterResetOptions,
  LightsLoadTypes,
  LightsVoltageOptions,
} from '@/../client-generator/generated-clients/plants';

@Options({
  name: 'LightsActuatorSettings',
})
export default class LightsActuatorSettings extends DeviceSettingsComponent {
  RelayStatusAfterResetOptions = RelayStatusAfterResetOptions;
  LightsLoadTypes = LightsLoadTypes;
  LightsVoltageOptions = LightsVoltageOptions;

  get settings() {
    return this.defaultSettings.lightsActuatorSettings;
  }
}
